var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LogMessage',{attrs:{"text":_vm.logContent}})}
var staticRenderFns = []

export { render, staticRenderFns }